import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Link from '@mui/material/Link';
import Zoom from '@mui/material/Zoom';
import { toast } from 'react-toastify';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import Level2Resources from './Level2Resources';
import Level3s from './Level3s';
import EnhancedDataGrid from '../Common/EnhancedDataGrid'; import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import { getFilter, setFilter } from '../Common/Utilities';
import ViewClientResourcesLookup from '../Lookups/ViewClientResourcesLookup';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});


export default class CLList extends React.Component {
	constructor() {
		super();

		this.state = {
			data: [],
			lastUpdated: "",
			systemType: "",
			selectedClientCode: "",
			selectedClientName: "",
			selectedMediaType: "" ,
			openLevel2ResourcesDialog: false,
			openViewResourcesDialog: false,
			openLevel3Dialog: false,
			filterText: getFilter(["SystemSetup", "Clients", "searchText"]) || '',
			sortModel: getFilter(["SystemSetup", "Clients", "sortModel"]) || [],
		};
		this.refresh_clickHandler = this.refresh_clickHandler.bind(this);
		this.viewLevel2Resources_clickHandler = this.viewLevel2Resources_clickHandler.bind(this);
		this.level2ResourcesDialog_closeHandler = this.level2ResourcesDialog_closeHandler.bind(this);
		this.viewLevel3_clickHandler = this.viewLevel3_clickHandler.bind(this);
		this.level3Dialog_closeHandler = this.level3Dialog_closeHandler.bind(this);
		this.mainGridRef = React.createRef();
	}
	getRefreshButton = () => {
		return <IconButton
			variant="contained"
			onClick={this.refresh_clickHandler}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10, display: 'none' }}>
			<RefreshIcon />
		</IconButton>;
	}

	refresh_clickHandler(event) {
		this.props.inProgress(true);

		let functionName = "getlevel2";
		let messageName = "Level 2";
		httpGet("/api/Adapter/getSyncData/" + functionName)
			.then(response => {
				var data = response.data;
				this.props.inProgress(false);
				if (data)
					toast.success(messageName + ' Fetched Successfully');
				else
					toast.error('Error fetching ' + messageName);

			}).catch((error) => {
				this.props.inProgress(false);
				toast.error('Error fetching ' + messageName);
			});
	}
	componentDidMount() {

		const gridRef = this.mainGridRef?.current;
		if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {
			gridRef.setQuickFilterValues([this.state.filterText]);
		}
		this.fetchLevel2s();
	}

	viewResources_clickHandler = (event, row) => {
		event.preventDefault();
		this.setState({
			openViewResourcesDialog: true,
			selectedClientCode: row.clientCode,
			selectedClientName: row.clientName,
			selectedMediaType: "DEFAULT"
		});
	}

	viewResourcesDialog_closeHandler = () => {
		this.setState({ openViewResourcesDialog: false });
	}

	viewLevel2Resources_clickHandler(event) {
		event.preventDefault();

		this.setState({ openLevel2ResourcesDialog: true, selectedLevel2Key: event.target.dataset.level2key });
	}

	level2ResourcesDialog_closeHandler(event) {
		this.setState({ openLevel2ResourcesDialog: false });
	}

	viewLevel3_clickHandler(event) {
		event.preventDefault();

		this.setState({ openLevel3Dialog: true, selectedLevel2Key: event.target.dataset.level2key });
	}	

	level3Dialog_closeHandler(event) {
		this.setState({ openLevel3Dialog: false });
	}

	fetchLevel2s() {
		var that = this;

		this.props.inProgress(true);

		httpGet('/api/setup/clientslist/')
			.then((response) => {
				var data = response.data;

				var localDateString = data.lastUpdated == null ? "" : new Date(data.lastUpdated).toLocaleString();
				let records = (data.records || []).map((e, i) => { let d = { ...e, rowId: i }; return d; });

				that.setState({ data: records, lastUpdated: localDateString, systemType: data.systemType || "" });

				this.props.inProgress(false);
			})
			.catch((error) => {
				this.props.inProgress(false);
				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
			});
	}

	render() {
		const info = {
			level2Key: this.state.selectedLevel2Key,
			inProgress: this.props.inProgress
		}
		let count = 1;

		return (
			<div>
				<h1>Clients</h1>
				<div className="form-group">
				<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={this.state.data}
							disableColumnMenu
							pagination
							gridRef={this.mainGridRef}
							pageSize={10}
							title={"Last Updated: " + this.state.lastUpdated}
							customcomponent={this.getRefreshButton()}
							setFilterText={(text) => {
								const trimmed = text?.trim() || '';
								this.setState({ filterText: trimmed }, () => {
									setFilter(['SystemSetup', "Clients", 'searchText'], trimmed);
								});
							}}
							highlightSearchTextOnMainScreenGrid={true}
							onSortModelChange={(model) => {
								this.setState({ sortModel: model });
								setFilter(['SystemSetup', "Clients", 'sortModel'], model);
							}}
							sortModel={this.state.sortModel}
							columns={[
								{
									headerName: 'Client Code',
									field: 'clientCode',
									width: 340
								},
								{
									headerName: 'Client Name',
									field: 'clientName',
									width: 1000
								},								
								//{
								//	headerName: 'Resource Mapping',
								//	headerAlign: 'center',
								//	align: 'center',
								//	field: 'activities', resizable: false, sortable: false,
								//	width: 100,
								//	renderCell: rowData => <Link data-level2key={rowData.row.level2Key} href="/Resources/CLResourceMapping">View</Link>

								//}

								this.state.systemType.toLowerCase() === "nexelus" && {
									headerName: 'Resources',
									headerAlign: 'center',
									align: 'center',
									field: 'viewResources',
									resizable: false,
									sortable: false,
									width: 130,
									renderCell: rowData => (
										<Link
											href="#"
											onClick={(e) => this.viewResources_clickHandler(e, rowData.row)}
										>
											View
										</Link>
									)
								},
								this.state.systemType.toLowerCase() === "mediaoceanprisma" &&  {
									headerName: 'Resource Mapping',
									headerAlign: 'center',
									align: 'center',
									field: 'activities',
									resizable: false,
									sortable: false,
									width: 130,
									renderCell: rowData => {
										const { clientCode, clientName } = rowData.row;
										const queryParams = new URLSearchParams({
											clientCode: clientCode,
											clientName: clientName
										}).toString();

										return (
											<Link
												data-level2client={clientCode}
												href={`/Resources/CLResourceMapping?${queryParams}`}
											>
												Edit
											</Link>
										);
									}
								}
							].filter(Boolean)}
							getRowId={(row) => row.rowId}
							disableSelectionOnClick
						/>
					</div>
				</div>
				<Dialog open={this.state.openLevel2ResourcesDialog} TransitionComponent={Transition} fullWidth maxWidth="lg">
					<DialogContent>
						<Level2Resources info={info} />
					</DialogContent>
					<DialogActions>
						<Button autoFocus onClick={this.level2ResourcesDialog_closeHandler} color="primary">
							Close
					</Button>
					</DialogActions>
				</Dialog>
				<ViewClientResourcesLookup
					openDialog={this.state.openViewResourcesDialog}
					onClose={() => this.viewResourcesDialog_closeHandler()}
					inProgress={this.props.inProgress}
					// These will be used to build the internal query string if needed, 
					// but we are simulating the 'Route' behavior
					clientCode={this.state.selectedClientCode}
					clientName={this.state.selectedClientName}
					mediaType={this.state.selectedMediaType}
				/>
				<Dialog open={this.state.openLevel3Dialog} TransitionComponent={Transition} fullWidth maxWidth="lg">
					<DialogContent>
						<Level3s info={info} />
					</DialogContent>
					<DialogActions>
						<Button autoFocus onClick={this.level3Dialog_closeHandler} color="primary">
							Close
					</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}
